import styled from 'styled-components';

export const HeaderbrandRight = styled.div`
@media screen and (max-width:767px) {
    // position: fixed;
    // bottom: 0;
    // display: inline-flex;
    // width: 100%; 
    // background:#01606F;
    // left: 0;
    // justify-content: center;
    // padding: 15px 0;
    // gap: 20px; 
    // z-index:9999;
 } 
    .headerbrandright{
        display: flex;
        align-items: center;
        column-gap: 15px; 
      
        
        @media screen and (max-width:1440px) { 
            column-gap: 5px;
        }
        @media screen and (max-width:1024px) { 
            flex-direction: row;
            padding-right: 45px;
        }

        @media screen and (max-width:767px) { 
            display: contents; 
        } 
      @media screen and (max-width:1024px) { 
        .user-write-review.desktop-review{
          display:none;
        }
     }
    @media screen and (max-width:1024px) { 
           .desktop-view-user{
            display:none;
           }
      }
    }
`;
export const WriteaReview = styled.div`

    .write-yellow-btn { 
        @media screen and (max-width:1440px) {
        padding: 11px 13px;
        white-space: nowrap;
    }
    @media screen and (max-width:767px) {
        padding: 7px 23px;
        white-space: nowrap;
    }
 }
  
`;
export const SpanButton = styled.div`

`;

export const UserBtn = styled.div`
.login-btn.dropdown-toggle {
    background: transparent !important;
    border: 2px solid #F9DC70 !important;
    &:hover{
        background:#F9DC70 !important;
    }
}
    .dropdown{
        padding-top: 2px; 
        
        button{
            &.login-btn{
                font-family: "Jost", sans-serif;
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                font-style: normal;
                display: flex;
                align-items: center;
                box-shadow: 3px 5px 20px #00000033;
                border: 2px solid #F9DC70;
                border-radius: 10px;
                column-gap: 5px;
                 padding: 8px 11px;
                background: transparent;
                transition: all 0.5s;
                
                &:hover, &.show{
                    background: #F9DC70 !important;
                    border-color: #F9DC70!important;
                    color: #333333 !important;
                    transition: all 0.5s;
        
                    svg {
                        #profile-circle {
                            path{
                                stroke: #333333;
                                transition: all 0.5s;
        
                                &#Vector-3, &#Vector-4{
                                    fill: #333333;
                                    transition: all 0.5s;
                                }
                            }
                        }
                    }
                }
            }
        }
        button{
               padding: 4px 8px 5px 4px;
            background: #33A7AE !important;
            display: flex;
            align-items: center;
            column-gap: 8px;
            border-color: #33A7AE !important;

            .user-icon{
                width: 34px;
                height: 34px;
                box-shadow: 3px 10px 20px #00000033;
                border-radius: 8px;
            }

            &::after{
                display: none;
            }
            &:hover{
                color: #fff;
            }
            .down-arrow-icon{
                margin-left: 13px;
            }
        }
        &:hover {
            .dropdown-menu {
                display: block;
                margin-top: 0px;
            }
        }

        .dropdown-menu {
            display: none;
            background: #FFFFFF;
            box-shadow: 0px 10px 30px #00000033;
            border-radius: 10px;
            padding: 15px 20px;
           
            @media screen and (max-width:1440px) {
                left: -3px;
            
           }
          @media screen and (max-width:1366px) {
                      left: -39px;
            
           }
         @media screen and (max-width:1280px) {
                left: -66px;
            
           }
            .dropdown-item{
                padding: 0;
                color: #333333;
                font-family: "Jost", sans-serif;
                font-size: 16px;
                line-height: 26px;
                margin-bottom: 15px;
                background: transparent;
                    @media screen and (max-width:1440px) {
                      margin-bottom: 5px;
                    
                    }
                &:last-child{
                    margin-bottom: 0;
                }
            }
        }
    }
`;
export const Username = styled.span`
    font-family: "Jost", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px; 
    font-style: normal;
    white-space: nowrap;
    width: 45px;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const DropMenu = styled.div`
    padding-top: 2px;
`;